export const LOCALE = process.env.REACT_APP_LOCALE;
export const DEFAULT_LOCALE = "en_us";
export const VALID_LOCALES = ["en_us", "id", "zh", "ja", "ur", "jp", "es"];
export const COUNTRY = process.env.REACT_APP_COUNTRY;
export const POSTAL_CODE_COUNTRY = process.env.REACT_APP_POSTAL_CODE_COUNTRY;
export const ECOM_API_KEY = process.env.REACT_APP_ECOM_API_KEY;
export const ENV = process.env.REACT_APP_ENV;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const GOOGLE_RECAPTCHA_CLIENT_KEY =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_CLIENT_KEY;
export const ROLLBAR_ACCESS_TOKEN = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN;
export const ADOBE_LAUNCH_CODE = process.env.REACT_APP_ADOBE_LAUNCH_CODE;
export const CLEVERTAP_ACCOUNT_ID = process.env.REACT_APP_CLEVERTAP_ACCOUNT_ID; // used by legacy
export const FACEBOOKPIXEL_ACCOUNT_ID =
  process.env.REACT_APP_FACEBOOKPIXEL_ACCOUNT_ID;
export const TIKTOKPIXEL_ACCOUNT_ID =
  process.env.REACT_APP_TIKTOKPIXEL_ACCOUNT_ID;
export const MYINFO_ENDPOINT = process.env.REACT_APP_MYINFO_ENDPOINT;
export const MYINFO_CLIENT_ID = process.env.REACT_APP_MYINFO_CLIENT_ID;
export const CIRCLES_PAYMENT_PLUGIN_ORIGIN_KEY =
  process.env.REACT_APP_ORIGIN_KEY;
export const CIRCLES_PAYMENT_PLUGIN_PATH =
  process.env.REACT_APP_CIRCLES_PAYMENT_PLUGIN_PATH;
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Circles.Life";
export const BRAND_FAVICON =
  process.env.REACT_APP_BRAND_FAVICON || "circles.life.ico";
export const BRAND_TITLE =
  process.env.REACT_APP_BRAND_TITLE ||
  "Finally a telco for the people, by the people. | Circles.Life";
export const BRAND_DESCRIPTION =
  process.env.REACT_APP_BRAND_DESCRIPTION || "The Best No-contract Mobile Plan";
export const SESSION_TIMEOUT = process.env.REACT_APP_SESSION_TIMEOUT || 55;
export const PAYMENT_STATUS_POLL_INTERVAL =
  process.env.REACT_APP_PAYMENT_STATUS_POLL_INTERVAL || 5000;
export const PAYMENT_STATUS_POLLING_COUNT_LIMIT =
  process.env.PAYMENT_STATUS_POLLING_COUNT_LIMIT || 10;
export const EP_PAYMENT_STATUS_POLLING_COUNT_LIMIT = 20; //added for easy pasia
export const IDENTITY_CHECK_POLL_MAX_COUNT = 6;
export const OLD_WEBFRONT_URL = process.env.REACT_APP_OLD_WEBFRONT_URL || "";
export const MOBILE_APP_DEEP_LINK =
  process.env.REACT_APP_MOBILE_APP_DEEP_LINK || "";
export const MOBILE_APP_BROWSER_PROTOCOL = "browser";
export const GTM_ID = `${process.env.REACT_APP_GTM_ID}` || "";
export const DELIVERY_SLOT_TYPE_SAD_SIM = "sad-sim-only";
export const DELIVERY_SLOT_TYPE_SIM = "sim-only";
export const DELIVERY_SLOT_TYPE_SIM_AND_PHONE = "sim-and-phone";
export const DELIVERY_SLOT_TYPE_PHONE = "phone-only";
export const IOS_DEVICE = "ios";
export const ANDROID_DEVICE = "android";
export const USE_REWARDS_CIS = process.env.REACT_APP_USE_REWARDS_CIS === "true";
export const TELCO_TENANT = process.env.REACT_APP_TELCO_TENANT;
export const PAYMENT_ENVIRONMENT =
  process.env.REACT_APP_PAYMENT_ENVIRONMENT || "TEST";
export const GOOGLE_EMBED_MAP_URL =
  "https://www.google.com/maps/embed/v1/place";
export const ZENDESK_CHAT_ACCOUNT_KEY =
  process.env.REACT_APP_ZENDESK_CHAT_ACCOUNT_KEY;
export const EVAM_SDK_KEY = process.env.REACT_APP_EVAM_WEB_CLIENT_KEY;
export const EVAM_API_HOST = process.env.REACT_APP_EVAM_API_HOST;
export const EVAM_LISTENER_URL = process.env.REACT_APP_EVAM_LISTENER_URL;
export const EVAM_ORIGIN_NAME = process.env.REACT_APP_EVAM_LOCAL_ORIGIN;
export const EVAM_AUTH_CHECK_RETRY_COUNT =
  process.env.REACT_APP_EVAM_AUTH_CHECK_RETRY_COUNT || 20;
export const EVAM_AUTH_CHECK_RETRY_TIME =
  process.env.REACT_APP_EVAM_AUTH_CHECK_RETRY_TIME || 500;

export const COUNTRIES_WITH_API_GATEWAY = ["jp", "cl"];
export const COUNTRIES_WITH_SECURED_PATHS = ["jp", "cl"];
export const COUNTRIES_WITH_LEGACY_APP = ["sg"];
export const LEGACY_APP_ENABLED = COUNTRIES_WITH_LEGACY_APP.includes(COUNTRY);
export const USE_API_GATEWAY = true;
export const IS_PATHS_SECURED = true;
export const PORTING_ACCOUNTS = process.env.REACT_APP_PORTING_ACCOUNTS || "";
export const TENANT_NAME = process.env.REACT_APP_TENANT_NAME || "webfront";
export const USE_PAYMENT_CARD_PATH =
  process.env.REACT_APP_USE_PAYMENT_CARD_PATH;

/******* ACYEN Variables ***/
export const ACYEN_USERNAME = process.env.REACT_APP_ACYEN_USERNAME || "";
export const ACYEN_PASSWORD = process.env.REACT_APP_ACYEN_PASSWORD || "";
export const ACYEN_TOKEN_URL = process.env.REACT_APP_ACYEN_TOKEN_URL || "";
export const ACYEN_SHIPPING_CARRIER_URL =
  process.env.REACT_APP_ACYEN_SHIPPING_CARRIER_URL || "";
export const ACYEN_VENDOR_CHANNEL_ID =
  process.env.REACT_APP_ACYEN_VENDOR_CHANNEL_ID || "";

/******* THEME COLORS *******/
export const SECONDARY_COLOR =
  process.env.REACT_APP_BRAND_SECONDARY_COLOR || "#C51398";
export const PRIMARY_COLOR =
  process.env.REACT_APP_BRAND_PRIMARY_COLOR || "#0000FF";
export const SPINNER_COLOR =
  process.env.REACT_APP_BRAND_SPINNER_COLOR || "#0015C4";

/******* Base URLS *******/
export const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;
export const API_EXTERNAL_ORDERS_URL = process.env.REACT_APP_API_GATEWAY_URL;
export const JOURNEY_MANAGER_URL = process.env.REACT_APP_API_GATEWAY_URL;
export const CUSTOMER_MANAGER_URL =
  process.env.REACT_APP_CUSTOMER_MANAGER ||
  process.env.REACT_APP_API_GATEWAY_URL;
export const USER_MANAGER = process.env.REACT_APP_USER_MANAGER;
export const MOBILE_APP_DEEP_LINK_QA =
  process.env.REACT_APP_MOBILE_APP_DEEP_LINK_QA;
export const MOCK_API_GATEWAY_URL = process.env.REACT_APP_MOCK_PAYMENT_URL;
export const WEBFRONT_V2_URL = process.env.REACT_APP_WEBFRONT_V2_URL;

export const FAQ_URL = {
  ONICS: "https://circles1867.zendesk.com/hc/en-us",
  CIRCLES: "https://circlesasiasupport.zendesk.com/hc/en-us",
  ANP: "https://circles1867.zendesk.com/hc/en-us "
};
export const BASE = {
  OMS: "OMS",
  CXOMS: "CXOMS",
  USER_SERVICE: "USER_SERVICE",
  USER_SERVICE_V5: "USER_SERVICE_V5",
  API_GATEWAY: "API_GATEWAY",
  API_GATEWAY_CXOS: "API_GATEWAY_CXOS",
  API_GATEWAY_QUILT: "API_GATEWAY_QUILT",
  API_GATEWAY_PORT_IN: "API_GATEWAY_PORT_IN",
  API_GATEWAY_PORTIN_CANCELLATION_ELIGIBILITY:
    "API_GATEWAY_PORTIN_CANCELLATION_ELIGIBILITY",
  LOGISTIC: "LOGISTIC",
  LOGISTICS: "LOGISTICS",
  PAYMENTS: "PAYMENTS",
  PAYMENTS_SERVICE: "PAYMENTS_SERVICE",
  REWARDS: "REWARDS",
  MOBILE_API: "MOBILE",
  CONFIG_API: "CONFIG_API",
  TELCO_SERVICE: "TELCO_SERVICE",
  TELCO_PORT_IN_SERVICE: "TELCO_PORT_IN_SERVICE",
  QUILT_SERVICE: "QUILT_SERVICE",
  REWARDS_SERVICE: "REWARDS_SERVICE",
  BILLING: "BILLING",
  IMS: "IMS",
  PORTIN: "PORTIN",
  AOL: "AOL",
  MOCK_PAYMENT: "MOCK_PAYMENT",
  NEW_IMS: "NEW_IMS",
  JOURNEY_MANAGER_URL: "JOURNEY_MANAGER_URL",
  CUSTOMER_MANAGER_URL: "CUSTOMER_MANAGER_URL",
  USER_MANAGER: "USER_MANAGER",
  PROFILE_PAYMENT_METHODS_URL: "PROFILE_PAYMENT_METHODS_URL",
  API_GATEWAY_CXOS_LOCAL: "API_GATEWAY_CXOS_LOCAL",
  API_GATEWAY_CMSUI_CONFIG: "API_GATEWAY_CMSUI_CONFIG",
  API_GATEWAY_OBM: "API_GATEWAY_OBM",
  API_EXTERNAL_ORDERS: "API_EXTERNAL_ORDERS",
  API_RE_KYC: "API_RE_KYC",
  ONIC_BASE: "ONIC_BASE",
  ONIC_DIRECT: "ONIC_DIRECT"
};

export const BASE_URL = {
  [BASE.OMS]: process.env.REACT_APP_OMS_URL || API_GATEWAY_URL,
  [BASE.CXOMS]: process.env.REACT_APP_OMS_URL || API_GATEWAY_URL,
  [BASE.USER_SERVICE]:
    process.env.REACT_APP_USER_SERVICE_URL || API_GATEWAY_URL,
  [BASE.USER_SERVICE_V5]: API_GATEWAY_URL,
  [BASE.PAYMENTS]: API_GATEWAY_URL,
  [BASE.PAYMENTS_SERVICE]:
    process.env.REACT_APP_PAYMENT_SERVICE_URL || API_GATEWAY_URL,
  [BASE.QUILT_SERVICE]:
    process.env.REACT_APP_QUILT_SERVICE_URL || API_GATEWAY_URL,
  [BASE.TELCO_SERVICE]:
    process.env.REACT_APP_TELCO_SERVICE_URL || API_GATEWAY_URL,
  [BASE.TELCO_PORT_IN_SERVICE]:
    process.env.REACT_APP_TELCO_SERVICE_URL || API_GATEWAY_URL,
  [BASE.API_GATEWAY]: API_GATEWAY_URL,
  [BASE.API_GATEWAY_PORT_IN]: API_GATEWAY_URL,
  [BASE.API_EXTERNAL_ORDERS]: API_GATEWAY_URL,
  [BASE.API_GATEWAY_PORTIN_CANCELLATION_ELIGIBILITY]: API_GATEWAY_URL,
  [BASE.API_GATEWAY_CXOS]: API_GATEWAY_URL,
  [BASE.LOGISTIC]: API_GATEWAY_URL,
  [BASE.LOGISTICS]: API_GATEWAY_URL,
  [BASE.REWARDS]: API_GATEWAY_URL,
  [BASE.REWARDS_SERVICE]: API_GATEWAY_URL,
  [BASE.MOBILE_API]: API_GATEWAY_URL,
  [BASE.CONFIG_API]: API_GATEWAY_URL,
  [BASE.BILLING]: API_GATEWAY_URL,
  [BASE.API_GATEWAY_QUILT]: API_GATEWAY_URL,
  [BASE.IMS]: process.env.REACT_APP_IMS_SERVICE_URL || API_GATEWAY_URL,
  [BASE.PORTIN]: API_GATEWAY_URL,
  [BASE.AOL]: API_GATEWAY_URL,
  [BASE.MOCK_PAYMENT]: MOCK_API_GATEWAY_URL,
  [BASE.NEW_IMS]: API_GATEWAY_URL,
  [BASE.JOURNEY_MANAGER_URL]: JOURNEY_MANAGER_URL,
  [BASE.CUSTOMER_MANAGER_URL]: CUSTOMER_MANAGER_URL,
  [BASE.USER_MANAGER]: USER_MANAGER,
  [BASE.PROFILE_PAYMENT_METHODS_URL]: process.env.REACT_APP_OMS_URL,
  [BASE.API_GATEWAY_CXOS_LOCAL]:
    process.env.REACT_APP_USER_SERVICE_URL || API_GATEWAY_URL,
  [BASE.API_GATEWAY_CMSUI_CONFIG]: process.env.REACT_APP_CMSAPI_MANAGER,
  [BASE.API_GATEWAY_OBM]: API_GATEWAY_URL,
  [BASE.API_RE_KYC]: process.env.REACT_APP_OMS_URL,
  [BASE.ONIC_BASE]: process.env.REACT_APP_OMS_URL,
  [BASE.ONIC_DIRECT]: process.env.REACT_APP_OMS_URL
};

export const OMS_URL = BASE_URL[BASE.OMS];
export const USER_SERVICE_URL = BASE_URL[BASE.USER_SERVICE];

/******** API version paths ********/
export const VERSION_PATH = {
  [BASE.OMS]: `/api/{VERSION}/${COUNTRY}/${TENANT_NAME}`,
  [BASE.CXOMS]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TENANT_NAME}`,
  [BASE.USER_SERVICE]: "/api/{VERSION}/user-service",
  [BASE.API_GATEWAY]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TENANT_NAME}`,
  [BASE.API_GATEWAY_PORT_IN]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TENANT_NAME}`,
  [BASE.API_EXTERNAL_ORDERS]: "/{VERSION}",
  [BASE.API_GATEWAY_PORTIN_CANCELLATION_ELIGIBILITY]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TENANT_NAME}`,
  [BASE.API_GATEWAY_CXOS]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TENANT_NAME}`,
  [BASE.LOGISTIC]: "/{VERSION}",
  [BASE.LOGISTICS]: "/{VERSION}",
  [BASE.PAYMENTS]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TENANT_NAME}`,
  [BASE.PAYMENTS_SERVICE]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TENANT_NAME}`,
  [BASE.MOBILE_API]: `/{VERSION}/${COUNTRY}/{LOCALE}/mobile`,
  [BASE.CONFIG_API]: `/{VERSION}/${COUNTRY}/{LOCALE}/${TENANT_NAME}`,
  [BASE.REWARDS]: "/{VERSION}/ecom/raas",
  [BASE.QUILT_SERVICE]: "/api/{VERSION}/quilt",
  [BASE.TELCO_SERVICE]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TELCO_TENANT}`,
  [BASE.TELCO_PORT_IN_SERVICE]: `/{VERSION}/${COUNTRY}/{LOCALE}/${TELCO_TENANT}`,
  [BASE.REWARDS_SERVICE]: `/{VERSION}/${COUNTRY}/{LOCALE}/mobile/rewards`,
  [BASE.API_GATEWAY_QUILT]: "/api/{VERSION}/quilt",
  [BASE.BILLING]: `/{VERSION}/${COUNTRY}/{LOCALE}/${TENANT_NAME}`,
  [BASE.IMS]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TENANT_NAME}`,
  [BASE.PORTIN]: "/{VERSION}/ufone/{LOCALE}/clx",
  [BASE.AOL]: `/{VERSION}/${COUNTRY}/{LOCALE}/clx`,
  [BASE.MOCK_PAYMENT]: `/{VERSION}/${COUNTRY}/{LOCALE}/cps`,
  [BASE.NEW_IMS]: "/{VERSION}",
  [BASE.JOURNEY_MANAGER_URL]: "/{VERSION}",
  [BASE.CUSTOMER_MANAGER_URL]: "/{VERSION}",
  [BASE.USER_MANAGER]: "/{VERSION}",
  [BASE.PROFILE_PAYMENT_METHODS_URL]: "/{VERSION}",
  [BASE.API_GATEWAY_CXOS_LOCAL]: "/{VERSION}",
  [BASE.API_GATEWAY_CMSUI_CONFIG]: "/{VERSION}/cl/{LOCALE}",
  [BASE.API_GATEWAY_OBM]: "/{VERSION}",
  [BASE.USER_SERVICE_V5]: `/v5/${COUNTRY}/{LOCALE}`,
  [BASE.API_RE_KYC]: "/v5",
  [BASE.ONIC_BASE]: "/{VERSION}",
  [BASE.ONIC_DIRECT]: "/api/v3"
};

export const OMS_VERSION_PATH = VERSION_PATH[BASE.OMS];
export const USER_SERVICE_VERSION_PATH = VERSION_PATH[BASE.USER_SERVICE];
export const API_GATEWAY_VERSION_PATH = VERSION_PATH[BASE.API_GATEWAY];

export const DEFAULT_API_VERSION = {
  [BASE.OMS]: "v3",
  [BASE.CXOMS]: "v2",
  [BASE.USER_SERVICE]: "v3",
  [BASE.API_GATEWAY]: "v4",
  [BASE.API_GATEWAY_PORT_IN]: "v1",
  [BASE.API_EXTERNAL_ORDERS]: "v1",
  [BASE.API_GATEWAY_PORTIN_CANCELLATION_ELIGIBILITY]: "v2",
  [BASE.API_GATEWAY_CXOS]: "v2",
  [BASE.LOGISTIC]: "v1",
  [BASE.LOGISTICS]: "v2",
  [BASE.PAYMENTS]: "v4",
  [BASE.PAYMENTS_SERVICE]: "v3",
  [BASE.REWARDS]: "v1",
  [BASE.MOBILE_API]: "v5",
  [BASE.CONFIG_API]: "v5",
  [BASE.QUILT_SERVICE]: "v1",
  [BASE.TELCO_SERVICE]: "v1",
  [BASE.TELCO_PORT_IN_SERVICE]: "v2",
  [BASE.REWARDS_SERVICE]: "v4",
  [BASE.BILLING]: "v4",
  [BASE.API_GATEWAY_QUILT]: "v1",
  [BASE.IMS]: "v2",
  [BASE.PORTIN]: "v2",
  [BASE.AOL]: "v1",
  [BASE.MOCK_PAYMENT]: "v1",
  [BASE.JOURNEY_MANAGER_URL]: "v1",
  [BASE.CUSTOMER_MANAGER_URL]: "v2",
  [BASE.USER_MANAGER]: "v5",
  [BASE.PROFILE_PAYMENT_METHODS_URL]: "v4",
  [BASE.API_GATEWAY_CXOS_LOCAL]: "v1",
  [BASE.API_GATEWAY_CMSUI_CONFIG]: "v3",
  [BASE.API_GATEWAY_OBM]: "v1",
  // [BASE.API_GATEWAY_OBM]: "v3"
  [BASE.API_GATEWAY_OBM]: "v3",
  [BASE.API_RE_KYC]: "v5",
  [BASE.ONIC_BASE]: "v6"
};

export const HEADER_SERVICE = {
  CXOMS: "cxoms"
};
/****** APIs *******/
export const OMS_APP_SETTINGS = "/checkout/app_settings";
export const OMS_LOCALE = "/locale";
export const OMS_BASE_PLAN = "/checkout/base_plan";
export const OMS_ELIGIBLE_PLANS = "/checkout/eligible_plans";
export const OMS_DELIVERY_SLOTS = "/checkout/delivery_slots";
export const OMS_NUMBERS = "/checkout/numbers";
export const OMS_PHONES = "/checkout/phones";
export const OMS_POST_OFFICE_DELIVERY_SLOTS =
  "/checkout/post_office_delivery_slots";
export const OMS_ORDER_STATUS = "/orders/status";
export const OMS_AUTHORIZE_ORDER = "/orders/{id}/get_authorizer";
export const OMS_SET_AUTHORIZE_ORDER = "/orders/{id}/set_authorizer";
export const OMS_GUEST_ORDER = "/orders/guest_order";
export const OMS_DO_KYC = "/orders/do_kyc";
export const OMS_VALIDATE_REFERRAL_CODE = "/checkout/verify_referral_code";
export const OMS_VALIDATE_PORT_IN_NUMBER = "/checkout/port_number_check";
export const VALIDATE_PORT_IN_NUMBER =
  "/portins/account/eligibility/create-portin";
export const OMS_VALIDATE_POSTAL_CODE = "/checkout/check_postal_valid";
export const OMS_SEARCH_ADDRESS_LOOKUP = "/checkout/search_address_lookup";
export const OMS_LOAD_ADDRESS_LOOKUP = "/checkout/load_address_lookup";
export const OMS_FIND_ADDRESS_LOOKUP = "/checkout/find_address_lookup";
export const OMS_ADDRESS_COMPONENT_MAPPINGS =
  "/checkout/address_component_mappings";
export const OMS_NUMBER_LOCK = "/checkout/number_lock";
export const OMS_VERIFY_SELF_ACTIVATION_DELIVERY_NRIC =
  "/checkout/sad/validate_nric";
export const OMS_VERIFY_IDENTITY = "/checkout/verify_identity";
export const OMS_VALIDATE_ICCID = "/checkout/validate_iccid";
export const OMS_SAD_VALIDATE_ICCID = "/checkout/sad_order/validate_identity";
export const OMS_ORDER_DETAILS = "/orders/details";
export const OMS_PAYMENT_RETURN = "/orders/payment_details";
export const OMS_SELF_ACTIVATION_DELIVERY = "/orders/details";
export const OMS_SUSPENSION_PAYMENT_DETAILS = "/suspension/payment_details";
export const OMS_SUBMIT_NUMBER_CHANGE = "/number_change/submit";
export const OMS_CANCEL_NUMBER_CHANGE = "/number_change/cancel";
export const OMS_SUBMIT_SUSPENSION = "/suspension/submit";
export const OMS_CANCEL_SUSPENSION = "/suspension/cancel";
export const OMS_SUBMIT_WINBACK = "/termination/winback";
export const OMS_SUBMIT_TERMINATION = "/termination/submit";
export const OMS_CANCEL_TERMINATION = "/termination/cancel";
export const OMS_CANCEL_PORT_IN = "/orders/cancel_port_in";
export const OMS_REINITIATE_PORT_IN =
  "/orders/reinitiate_portin_update_details";
export const OMS_RESCHEDULE_PORT_IN = "/orders/reschedule_port_in";
export const OMS_ACTIVATE_SIM_CARD = "/orders/activate_sim_card";
export const PLAN_SWITCH_CREATE_REQUEST = "/cxos-oms/orders";
export const PLAN_SWITCH_RESUBMIT_KYC =
  "/cxos-oms/orders/sim_replacement/{orderRef}/resubmit_kyc";
export const OMS_CREATE_ORDER_TEMP = "/orders/create_order_temp";
export const OMS_UPDATE_SAD_ORDER = "/orders/sad_orders";
export const OMS_RESEND_ESIM_QR_CODE = "/orders/send_esim_qr_code";
export const OMS_CREATE_SAD_ORDER = "/orders/sad_orders";
export const OMS_EKYC_COMPLETED = "/checkout/ekyc_completed";
export const OMS_FETCH_ORDER_STATUS = "/orders/status";
export const OMS_CONFIRM_PAYMENT_OPTION = "/paas/ecpay/confirm_payment_option";
export const OMS_FETCH_PAYMENT_REQUEST = "/orders/payment_request";
export const OMS_SECURED_FETCH_PAYMENT_REQUEST =
  "/orders/secured_payment_request";
export const OMS_VERIFY_PAYMENT = "/orders/verify_payment";
export const OMS_SUBMIT_REPLACE_SIM = "/replace_sim/submit";
export const OMS_SUBMIT_SWITCH_TO_ESIM = "/replace_sim/submit";
export const OMS_DELIVERY_INFO = "/deliveries/info";
export const OMS_SUBMIT_DELIVERY = "/deliveries/submit";
export const OMS_UPLOAD_IDENTITY_DETAILS = "/identities/info";
export const OMS_SUBMIT_UPLOAD_IDENTITY = "/identities/submit";
export const OMS_MYINFO_OTP = "/checkout/myinfo/send_otp";
export const OMS_FETCH_SURVEY = "/surveys/new";
export const OMS_SUBMIT_SURVEY = "/surveys/submit";
export const OMS_IDENTITY_VERIFICATION_STATUS = "/checkout/get_dvs_status";
export const OMS_JUMIO_VERIFICATION_URL = "/checkout/jumio/verification";
export const OMS_CUSTOMER_INFO = "/checkout/get_customer_info";
export const OMS_USER_WALLET = "/wallet/get_user_wallet";

export const OMS_UPLOAD_IMAGE = "/checkout/upload_image";
export const OMS_UPLOAD_SCREENSHOT = "/checkout/upload_screenshot";
export const OMS_REQUEST_OTP = "/auth/otp";
export const OMS_VERIFY_OTP = "/auth/verify_otp";
export const OMS_LOG_MESSAGE = "/analytics/log_message";

export const PHONES_URL = "/shop/phones";
export const MANAGE_ORDER_URL = "/manage/order";
export const SIM_ACTIVATION_URL = "/sim_activation/sim";
export const OMS_PROCESS_PREPAID_ORDER = "/orders/prepaid/process";
export const OMS_TRANSACTION_DETAILS = "/billing/transaction";

export const OMS_GET_CITY_LIST = "/post_offices/get_city_list";
export const OMS_GET_DISTRICT_LIST = "/post_offices/get_district_list_by_city";
export const OMS_GET_STREET_LIST =
  "/post_offices/get_street_by_district_and_city";
export const OMS_GET_STORE_LIST =
  "/post_offices/get_store_by_street_district_city";
export const OMS_ORDER_CANCELLATION_STATUS = "/cancellation/account";
export const OMS_ORDER_CANCELLATION = "/cancellation/submit";

export const OMS_POP_STATIONS = "/checkout/popstations";

export const OMS_VALIDATE_SIGNATURE = "/auth/validate_signature";
export const OMS_OUTSTANDING_BILLS = "/billing/outstanding_bills";
export const OMS_PAY_OUTSTANDING_BILLS = "/billing/pay_outstanding_bills";
export const OMS_CHECK_PAYMENT_STATUS = "/transaction/status";
export const MOCK_PAYMENT = "/stripe/internal/call-back/payment";

export const OMS_MYINFO = "/checkout/myinfo";
export const OMS_MYINFO_SEND_OTP = "/checkout/myinfo/send_otp";
export const OMS_MYINFO_VERIFY_OTP = "/checkout/myinfo/verify_otp";

/** ONBOARDIG JOURNEY reschedule service APIs */
export const OBJ_RESCHEDULE_DELIVERY = `/${COUNTRY}/${LOCALE}/web/webfront/slots/reschedule`;
export const VALIDATE_PORT_IN_NUMBER_AND_TELCO = `/${COUNTRY}/${LOCALE}/clx/customers/validate`;

/** Customer Manager API'S */
export const PLAN_ADDON_BENEFITS = "/webfront/raas/promotions";
export const SUGGESTED_ADDONS = "/cl/internal/product-variants/eligible";
export const ORDER_PREVIEW = "/order/user/orderpreview";
export const VALIDATE_PROMO_CODES = "/promotions/user/rewards";

/** promo/reward logic from journeyManager layer  */
export const ALL_PROMOTIONS = "/webfront/raas/promotions/all";
export const DELIVERY_FEE_SKU = "/slots/{slotId}";

/** LASS reschedule delivery  APIs */
export const LASS_RESCHEDULE_DELIVERY = "/shipments/reschedule";

/** User service APIs */
export const USER_SERVICE_LOGIN = `/v4/${COUNTRY}/{LOCALE}/webfront/users/login/action`;
export const USER_SERVICE_OTP = `/v4/${COUNTRY}/{LOCALE}/webfront/otp`;
export const USER_SERVICE_SIGNUP_GENERATE_OTP = `/v5/${COUNTRY}/${LOCALE}/web/signup/generate-otp`;
export const USER_SERVICE_SIGNUP_RESEND_OTP = `/v5/${COUNTRY}/${LOCALE}/web/signup/resend-otp`;
export const USER_SERVICE_SIGNUP_VALIDATE_OTP = `/v5/${COUNTRY}/${LOCALE}/web/signup/validate-otp`;
export const USER_SERVICE_LOGIN_GENERATE_OTP = `/v5/${COUNTRY}/${LOCALE}/web/signin/generate-otp`;
export const USER_LOGIN_GENERATE_OTP = "/signin/otp";
export const USER_SERVICE_LOGIN_RESEND_OTP = `/v6/${COUNTRY}/${LOCALE}/web/signin/otp-resend`;
export const USER_SERVICE_LOGIN_VALIDATE_OTP = `/v5/${COUNTRY}/${LOCALE}/web/signin/validate-otp`;
export const USER_SERVICE_AUTHENTICATE = `/v4/${COUNTRY}/{LOCALE}/webfront/users/auth`;
export const USER_SERVICE_REFRESH_TOKEN = `/v4/${COUNTRY}/${LOCALE}/webfront/users/token`;
export const USER_SERVICE_LOGGEDIN_USER_DETAILS = "/cl/en/web/users";
export const USER_SERVICE_LINK_SOCIAL = `/v4/${COUNTRY}/{LOCALE}/webfront/users/link-social`;
export const USER_SERVICE_LIQUID_URL = `/v4/${COUNTRY}/en/webfront/kyc/url`;
export const USER_SERVICE_LIQUID_OCR_DATA = `/v4/${COUNTRY}/en/webfront/kyc/ocr-result`;
export const USER_SERVICE_LIQUID_OCR_REGISTER = `/v4/${COUNTRY}/en/webfront/kyc/submit`;
export const USER_SERVICE_REQUEST_OTP_V4_SECURE = `/v4/${COUNTRY}/{LOCALE}/mobile/secure-otp`;
export const USER_SERVICE_VALIDATE_OTP = `/v4/${COUNTRY}/{LOCALE}/webfront/users/otp/validate`;
export const USER_SERVICE_VALIDATE_OTP_TRIGGER = `/v4/${COUNTRY}/{LOCALE}/webfront/otp/validate/trigger`;
export const USER_SERVICE_UPDATE_EMAIL = `/v4/${COUNTRY}/{LOCALE}/webfront/users/attributes`;
export const USER_LOGOUT_PATH = "/users/logout";
export const USER_SERVICE_LOGOUT = `/v4/${COUNTRY}/{LOCALE}/webfront${USER_LOGOUT_PATH}`;
export const USER_SERVICE_USER_KYC = `/v4/${COUNTRY}/{LOCALE}/webfront/fetch-mno-kyc`;
export const USER_SERVICE_SUBMIT_USER_KYC = `/v4/${COUNTRY}/{LOCALE}/webfront/submit-mno-kyc`;
export const USER_SERVICE_EMAIL_OTP = `/v3/${COUNTRY}/{LOCALE}/webfront/users/auth/otp/send`;
export const USER_SERVICE_VALIDATE_EMAIL_OTP = `/v3/${COUNTRY}/{LOCALE}/webfront/users/auth/otp/validate`;
export const USER_SERVICE_MANUAL_EKYC = `/v5/${COUNTRY}/{LOCALE}/mobile/kyc/submit`;
export const USER_SERVICE_KYC_DETAILS = `/v5/${COUNTRY}/{LOCALE}/web/kyc`;
export const USER_SERVICE_KYC_CONFIG = `/v5/${COUNTRY}/{LOCALE}/web/kyc/config`;
export const USER_SERVICE_OTT_GENERATE = `/v5/${COUNTRY}/{LOCALE}/web/ott/generate`;
export const USER_SERVICE_OTT_RESEND = `/v5/${COUNTRY}/{LOCALE}/web/ott/resend`;
export const USER_SERVICE_UPDATE_USER_PROFILE = `/v5/${COUNTRY}/{LOCALE}/web/users/profile/update`;
export const USER_SERVICE_ANALYTICS_PREFERENCES = `/v5/${COUNTRY}/{LOCALE}/web/users/analytics-preferences/WEB`;
export const USER_SERVICE_GUEST_SIGNUP = "/web/guest-signup";
export const USER_SERVICE_GUEST_OTT_VALIDATE = "/web/ott/validate";
export const DEFAULT_ANALYTICS_PREFERENCES = `/v5/${COUNTRY}/{LOCALE}/web/config/default-preferences`;
export const NATIONALITY_LIST = `/v5/${COUNTRY}/{LOCALE}/web/config/nationalities`;

export const ADD_NEW_PAYMENT_METHOD = `/${COUNTRY}/${LOCALE}/${TENANT_NAME}/customers/{id}/payment-methods`;
export const EDIT_PAYMENT_METHOD = `/v4/${COUNTRY}/${LOCALE}/tenant/customers/{id}/payment-methods/{id}`;
export const UPDATE_DEFAULT_PAYMENT_METHOD = `/${COUNTRY}/${LOCALE}/${TENANT_NAME}/customers/{id}/payment-methods/default`;
export const ENABLED_PAYMENT_METHODS = `/${COUNTRY}/${LOCALE}/${TENANT_NAME}/global/payment-methods/enabled?recurrent={recurrent}`;
export const SAVED_PAYMENT_METHODS = `/${COUNTRY}/${LOCALE}/${TENANT_NAME}/customers/{id}/payment-methods`;
export const REMOVE_PAYMENT_METHOD = `/${COUNTRY}/${LOCALE}/${TENANT_NAME}/customers/{id}/payment-methods`;
export const ENABLED_LANGUAGE_METHODS = `v1/${COUNTRY}/${LOCALE}/web/localisation/languages`;
/** Api Gateway APIs */
export const API_CONSENT_RECODER = `/${COUNTRY}/${LOCALE}/web/user/consent/submit`;
export const API_LOCALIZATION = `/${COUNTRY}/${LOCALE}/${TENANT_NAME}/localisation/language/keys`;
export const API_MODULE_LOCALIZATION =
  "/localisation/language/keys?component=WEB&moduleName={moduleName}&langCode=en_us&pageSize=1000";
export const API_GATEWAY_CREATE_ORDER = "/orders";
export const API_GATEWAY_GET_ORDER_STATUS = "/cxos-oms/orders/{orderRef}";
export const API_GATEWAY_GET_CANCEL_PLAN_SWITCH_ORDER =
  "/cxos-oms/orders/{orderRef}/plan_switch/cancel";
export const API_GATEWAY_GET_CREATE_SIM_REPLACEMENT_ORDER =
  "/sim_replacement/orders";
export const API_GATEWAY_UPDATE_ORDER = "/cxos-oms/orders/update";
export const API_GATEWAY_APP_SETTINGS = "/cxos-oms/checkout/app_settings";
export const API_GATEWAY_QUILT_APP_SETTINGS = "/settings/webfront-settings";
export const API_GATEWAY_V1_GLOBAL_SETTINGS = "/global_config";
export const API_GATEWAY_QUILT_PRODUCT_VARIANTS = "/settings/product-variants";
export const API_GATEWAY_QUILT_LOCALE = "/proxy/webfront/locale";
export const API_GATEWAY_LOCALE = "/cxos-oms/locale";
export const API_GATEWAY_BASE_PLAN = "/cxos-oms/checkout/base_plan";
export const API_GATEWAY_ELIGIBLE_PLANS = "/cxos-oms/checkout/eligible_plans";
export const API_GATEWAY_PAYMENT_REQUEST = "/cxos-oms/orders/payment_request";
export const API_GATEWAY_FETCH_OUTSTANDING_BILL = "/external/paylink/{paylink}";
export const API_GATEWAY_PAYMENT_DETAILS = "/cxos-oms/orders/payment_details";
export const API_GATEWAY_PAYMENT_VERIFY =
  "/cxos-oms/paas/v2/cxos-oms/payment/verify";
export const API_GATEWAY_MANAGE_ORDER = "/cxos-oms/manage_order";
export const API_GATEWAY_RESCHEDULE_ORDER =
  "/cxos-oms/orders/reschedule_delivery/validate";
export const API_GATEWAY_QUILT_TERMINATION_STATUS =
  "/settings/termination-status";
export const API_GATEWAY_ESIM_QR = "/cxos-oms/manage_order/get_esim_qr_code";
export const API_GATEWAY_SIM_ACTIVATION_STATUS =
  "/cxos-oms/manage_order/sim_status";
export const API_GATEWAY_ACTIVATE_SIM_CARD = "/cxos-oms/orders/activate";
export const API_GATEWAY_ACTIVATE_REPLACE_SIM_CARD =
  "/cxos-oms/manage_order/activate_sim_replacement";
export const API_GATEWAY_INITIATE_PORTIN =
  "/cxos-oms/manage_order/initiate_portin";
export const API_GATEWAY_CANCEL_PORT_IN =
  "/cxos-oms/manage_order/cancel_port_in";
export const API_GATEWAY_LOG_MESSAGE = "/cxos-oms/analytics/log_message";
export const API_GATEWAY_SUBMIT_WINBACK = "/winback/claim";
export const API_GATEWAY_SUBMIT_TERMINATION = "/cxos-oms/termination/submit";
export const API_GATEWAY_CANCEL_TERMINATION = "/cxos-oms/termination/cancel";
export const API_GATEWAY_DELIVERY_DETAILS = "/cxos-oms/deliveries/info";
export const API_GATEWAY_DOWNLOAD_SERVICE_AGREEMENT =
  "/cxos-oms/orders/download_service_agreement_form";
export const API_GATEWAY_DOWNLOAD_PARENTAL_CONSENT =
  "/cxos-oms/orders/download_parental_consent";
export const API_GATEWAY_VALIDATE_REFERRAL_CODE =
  "/cxos-oms/checkout/verify_referral_code";
export const API_GATEWAY_SUBMIT_DELIVERY = "/cxos-oms/deliveries/submit";
export const API_GATEWAY_REQUEST_OTP = "/cxos-oms/auth/otp";
export const API_GATEWAY_ORDER_CANCELLATION_STATUS =
  "/cxos-oms/cancellation/account";
export const API_GATEWAY_ORDER_CANCELLATION =
  "/cxos-oms/orders/{order_ref}/cancel";
export const API_GATEWAY_ORDER_CANCELLATION_REASONS =
  "/cxos-oms/orders/cancel/reasons";
export const API_GATEWAY_TRANSACTION_STATUS = "/cxos-oms/transaction/status";
export const API_GATEWAY_UPDATE_PARENTAL_CONSENT =
  "/cxos-oms/orders/parental_consent";
export const API_GATEWAY_RESUBMIT_PORTIN_DETAILS =
  "/cxos-oms/manage_order/resubmit_mnp_number";
export const API_GATEWAY_OMS_NUMBER_LOCK = "/cxos-oms/checkout/number_lock";
export const API_GATEWAY_OMS_VALIDATE_POSTAL_CODE =
  "/cxos-oms/checkout/check_postal_valid";
export const API_GATEWAY_OMS_CANCEL_INCOMPLETE_ORDER =
  "/cxos-oms/orders/{order_ref}/cancel";
export const E_SIM_DELIVERY_CONFIG =
  "/webfront/orders/esim/delivery/specification";
export const ELIGIBILITY_LINE_PATH = "/eligibility/number-of-lines";
export const RE_SUBMIT_KYC_PATH = "/sg/en/web/kyc/submit?orderId={order_id}";
export const SAVED_PAYMENT_METHOD_REQUEST = "/external/{id}/payment-methods";
export const NEW_SAVED_PAYMENT_METHOD_REQUEST =
  "/customers/{id}/payment-methods";
export const LASS_RESCHEDULE_SHIPMENT_DELIVERY =
  "/shipments/reschedule/{reschedule-id}/payment";
export const API_GATEWAY_TRANSCTION_CANCEL =
  "/external/transaction/{cxt_id}/cancel?error_code={error_code}&error_msg={error_msg}";
export const API_GATEWAY_UPDATE = "/order/{orderRef}";
export const ADDRESS_API_GATEWAY_UPDATE = "/shipment/{shipmentReferance}";
export const SELF_PICKUP_LOCATION_UPDATE = "/shipments/pickup-location";
export const UNSUBSCRIBE =
  "/user-service/v5/cl/en/mobile/users/notification-preferences";
/** IMS service APIS */

export const IMS_NUMBERS = "/numbers";
export const IMS_NUMBER_LOCK = "/numbers/{number}/lock";
export const IMS_NUMBERS_CATEGORIES = "/numbers/categories";

/** external Daraz Pending Orders API */
export const API_EXTERNAL_PENDING_ORDERS =
  "/carts?email={email}&status=PENDING";
//export const API_GATEWAY_OMS_EXTERNAL_PENDING_ORDERS = "/carts"

/** Rewards service APIs */
export const REWARDS_VALIDATE_REFERRAL_CODE =
  "/user/promos/{REFERRAL_CODE}/validate";
export const REWARDS_REQUEST_WINBACK = "/winback/promotion";
export const CANCEL_TERMINATION = "/winback/claim";
/** Logistic service APIs */
export const LOGISTIC_DELIVERY_SLOTS = "/slots";
export const LOGISTIC_DELIVERY_SLOT_DETAILS = "/slots/{slotID}";
export const LOGISTIC_SELF_PICKUP_STATIONS =
  "/pickup-locations?zipcode={zipcode}";
export const LOGISTIC_RETAIL_STORES = "/retail-stores?storeId={storeId}";
export const LOGISTIC_SHIPPING_METHODS = "/delivery-methods";
export const LOGISTIC_SHIPPING_LOCATION_DETAILS =
  "/pickup-locations/{pickupLocationId}";
export const LOGISTIC_NUMBER_AND_DELIVERY_SLOT_AVAILABILITY =
  "/number/location/availability";
export const LOGISTIC_ADDRESS_MAPPING = "/internal/address-mappings/configs";
export const LOGISTIC_SELF_PICKUP_STATION_ADDRESS =
  "/pickup-locations?latitude={lat}&longitude={lng}&count=5";

/* Payment service APIs */
export const PROCESS_CARD_UPDATE_PAYMENT_METHOD =
  "/payment/save_card/process_payment_method";
export const PROCESS_PAYMENT_METHOD = "/payment/process_payment_method";
export const SAVE_AND_GET_CARD_DETAILS = "/payment/save_and_get_card_details";
export const SAVE_AND_GET_CARD_DETAILS_CXOS =
  "/external/payment/save-and-get-card-details";
export const UPFRONT_PAYMENT = "/payment/upfront";
export const LATITUDE_TRANSACTIONS_STATUS = "/latitude_transactions/status";
export const PAYMENT_TRANSACTION_STATUS = "/transaction/status";
export const PAYMENT_TRANSACTION_STATUS_CXOS = "/external/transaction/status";

export const TELCO_PROFILE = "/telco/profile";
export const PROFILE_PARAMETERS =
  "/domain-config/customer-profile/parameters/all";
export const CREATE_PORTOUT_REQUEST = "/portouts/account/create";
export const REVERSE_PORTIN = "/portouts/account/reverse-portin";

export const BILL_DETAILS = "/customers/bills/outstanding";
export const BILL_PAYMENT_INTENT = "/customers/bills/outstanding/payintent";
export const BILL_PAYMENT_STATUS =
  "/customers/bills/outstanding/payintent/status";
export const WALLET_AUTHENTICATE =
  "/payment-method/{payment-method-id}/authenticate";

/* Quilt service APIs */
export const QUILT_ELIGIBILITY = "/settings/eligibility?sin={sin_number}";
export const QUILT_ORDER_TERMINATION_REQUEST_DETAILS =
  "/settings/termination-request-details";
export const QUILT_PLAN_SWITCH_REQUEST_DETAILS =
  "/settings/plan-switch-request-details";
export const QUILT_WINBACK_AGGREGATION = "/settings/winback-aggregation";
export const QUILT_PROFILE_AGGREGATION = "/settings/profile-aggregation";
export const QUILT_SERVICE_REQUESTS =
  "/settings/service-requests?sin={sin_number}";
export const QUILT_HOME_BANNERS = "/home-banners";
export const QUILT_ELIGIBLE_PLAN = "/settings/product-variants";

/* Telco service APIs */
export const TELCO_REPORT_LOST_SIM = "/account-workflows/inventory/modify";
export const TELCO_REQUEST_TERMINATE = "/account-workflows/status/terminate";
export const TELCO_EMAIL_SERVICE_AGREEMENT = "/paradocs/account-subscriptions";
export const TELCO_RE_INITIATE_NUMBER_PORT_IN = "/portins/reinitiate";

/* CIS service APIs */
export const CIS_REQUEST = "/partners/request_for_cis_as_hr";
export const CIS_REQUEST_HR = "/partners/cis_request_to_hr";
export const CIS_PARTNERS = "/customers/generate_referral_code";
export const CIS_PARTNERS_REWARDS_FORM_FIELDS = "/promotions/partner";
export const CIS_PARTNERS_CMS_FORM_FIELDS = "/partners";

/* PORTIN service APIs */
export const PORTIN_DONOR_TELCO = "/portins/config/donor_telco";
export const PORTIN_MNPCONFIG_TELCO = "/portins/config";
export const CONFIGURATION = "/configuration";
export const PORT_IN_REQUEST = "/portins/{orderRef}/latest_by_order";
export const PORTIN_CANCELLATION_ELIGIBILITY =
  "/portins/account/eligibility/cancel-portin?portInNumber={port-in-number}";
export const CANCEL_PORTIN = "/portins/orders/{orderRef}";

/* AOL Service APIs */
export const AOL_CANCEL_TERMINATION = "/account-workflows/terminate/cancel";
export const AOL_TERMINATION_REASONS =
  "/account-workflows/specification/termination/reasons";

/* Analytics APIs */
export const CLICKSTREAM_API_PATH = "/topics/data.events.web.clickstream";

export const ORDER_ACTION_TYPES = {
  SUSPEND_NUMBER: "suspend_number",
  CHANGE_NUMBER: "change_number",
  REPORT_LOST_SIM_CARD: "report_lost_sim_card",
  REPORT_LOST_ESIM_CARD: "report_lost_esim_card",
  TERMINATE_NUMBER: "terminate_number",
  ACTIVATE_SIM_CARD: "activate_sim_card",
  SWITCH_TO_ESIM: "switch_to_esim",
  RESEND_ESIM: "resend_esim",
  OUTSTANDING_BILLS: "pay_outstanding_bills",
  ADD_CC: "add_cc",
  CANCEL_TERMINATION: "cancel_termination"
};

export const NUMBER_CATEGORIES = {
  STANDARD: "Standard"
};

export const STEP_ACTIONS = {
  ACTIVATE_SIM_CARD: "activate_sim_card",
  INITIATE_PORTIN: "initiate_portin",
  REINITIATE_PORTIN: "reinitiate_portin",
  RESCHEDULE_PORT_IN: "reschedule_port_in",
  CANCEL_PORTIN: "cancel_portin"
};

export const RESTRICTED_STEP_ACTIONS = [
  STEP_ACTIONS.ACTIVATE_SIM_CARD,
  STEP_ACTIONS.INITIATE_PORTIN,
  STEP_ACTIONS.REINITIATE_PORTIN,
  STEP_ACTIONS.RESCHEDULE_PORT_IN,
  STEP_ACTIONS.CANCEL_PORTIN
];

export const PAYMENT_STATES = {
  PENDING_ECPAY: "PENDING_ECPAY"
};

export const MARKETING_WEBSITE_URL_PARAMS = {
  PLAN_SKU: "planSku",
  PRODUCT_CATEGORY: "productCategory",
  SKIP_ADDONS: "skipAddons"
};

export const PAYMENT_STATUSES = {
  PENDING: "Pending",
  SUCCESS: "Success",
  FAILED: "Failed"
};

export const DATA_VALUE_TYPE = {
  MB: "megabytes",
  GB: "gigabytes"
};

export const SHIPMENT_METHOD = {
  SELF_PICKUP: "SELF_PICKUP",
  DOORSTEP_DELIVERY: "DOORSTEP_DELIVERY",
  RETAIL: "RETAIL"
};

export const SHIPMENT_METHOD_IGNORED_IN_SHIPPING_METHOD_SELECTOR = [
  SHIPMENT_METHOD.RETAIL
];

export const ALL_SHIPMENT_METHOD_ALLOWED = "ALL_SHIPMENT_METHOD_ALLOWED";

export const PAYMENT_STATUSES_CXOS = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  PENDING: "PENDING",
  CREATED: "CREATED"
};

export const SIM_TYPE_SKUS = {
  ESIM: "8888888888888"
};

export const PAYMENT_CARD_TYPES = {
  EASYPAISA_LINK: "link_easypaisa",
  EASYPAISA_ONETIME: "onetime_easypaisa"
};

export const PAYMENT_PARTNERS = {
  EASYPAISA: "easypaisa",
  PAYFAST: "payfast",
  EASYPAISA_WALLET: "easypaisa wallet",
  JAZZCASH: "jazzcash"
};

export const ERROR_MESSAGE_TYPES = {
  PAYMENT_POLLING: "payment_polling",
  PAYMENT_REQUEST: "payment_request"
};

export const SIM_ACTIVATION_STATUSES = {
  ORDER_PLACED: "OP",
  SUCCESS: "FD",
  CANCELLED: "CAN"
};

export const ORDER_ACTION_STATES = {
  SUSPENDABLE: "SUSPENDABLE",
  SUSPENSION_CANCELABLE: "SUSPENSION_CANCELABLE",
  TERMINATABLE: "TERMINATABLE",
  TERMINATE: "TERMINATE",
  CANCEL_AND_TERMINATE: "CANCEL_AND_TERMINATE",
  CANCELABLE: "CANCELABLE"
};

export const MANAGE_ORDER_FEATURE_MAPPINGS = {
  change_number: "SHOW_GUEST_ORDER_CHANGE_NUMBER_ACTION",
  suspend_number: "SHOW_GUEST_ORDER_SUSPEND_NUMBER_ACTION",
  report_lost_sim_card: "SHOW_GUEST_ORDER_REPORT_LOST_SIM_CARD_ACTION",
  terminate_number: "SHOW_GUEST_ORDER_TERMINATE_NUMBER_ACTION",
  cancel_termination: "SHOW_GUEST_ORDER_CANCEL_TERMINATION_ACTION",
  pay_outstanding_bills: "SHOW_GUEST_ORDER_PAY_OUTSTANDING_BILLS"
};

export const MANAGE_ORDER_TRANSLATION_MAPPINGS = {
  cancel_port_in: "manage_order_cancel_port_in",
  change_number: "manage_order_change_number",
  suspend_number: "manage_order_suspend_number",
  report_lost_sim_card: "manage_order_report_lost_sim_card",
  report_lost_esim_card: "manage_order_report_lost_esim_card",
  terminate_number: "manage_order_terminate_number",
  cancel_termination: "manage_order_cancel_termination",
  authorise_action: "manage_order_authorise_action",
  predeliver_action: "manage_order_predeliver_action",
  manage_order: "manage_order",
  activate_sim_card: "manage_order_activate_sim_card",
  switch_to_esim: "manage_order_switch_to_esim",
  resend_esim: "manage_order_resend_esim",
  pay_outstanding_bills: "manage_order_pay_outstanding_bills",
  add_cc: "manage_order_add_cc"
};

export const E_SIM_DELIVERY_CONFIG_TYPE = {
  new: "ESIM-NEW",
  replacement: "ESIM-SIM_REPLACMENT"
};

export const DATA_BUNDLE = {
  unlimitedLower: "unlimited",
  UnlimitedCamel: "Unlimited"
};

export const MANAGE_ORDER_OTP_MAPPINGS = {
  report_lost_sim_card: "email",
  switch_to_esim: "email",
  resend_esim: "email",
  manage_order: "email",
  default: "sms"
};

export const PAST_SERVICE_REQUEST_TYPES = {
  TERMINATION_REQUEST: "termination_request",
  SIM_REPLACEMENT_REQUEST: "sim_replacement_request",
  PLAN_SWITCH_REQUEST: "plan_switch_request"
};

export const VIDEO_ORIENTATIONS = {
  PORTRAIT: "portrait",
  LANDSCAPE: "landscape"
};

export const FAQ_TYPE = {
  TEXT: "text",
  VIDEO: "video"
};

export const MANAGE_PROFILE_OTP_MAPPINGS = {
  ENHANCED_SMS: "ENHANCED_SMS",
  ENHANCED_EMAIL_OTP: "ENHANCED_EMAIL_OTP"
};

export const MANAGE_PROFILE_REQUEST_TYPE_MAPPINGS = {
  VERIFY_MOBILE: "VERIFY_MOBILE",
  VERIFY_EMAIL_OTP: "VERIFY_EMAIL_OTP"
};

export const MANAGE_ORDER_ACTION_QUERY_PARAM_REQUIRED = {
  terminate_number: "showTerminate"
};

export const CALENDAR_YEAR_OFFSET = {
  MINGUO: 1911
};

export const PREPAID_PLAN_SUB_TYPES = ["RETAIL_PREPAID"];

export const paths = {
  LANDING_PAGE: "/",
  MY_ORDERS: "/orderlist",
  CONFIGURATION_INSTRUCTIONS: "/configuration/instruction",
  MANAGE_ORDER_AUTHORIZED: "/orders/authorize/:status?",
  MANAGE_ORDER: "/manage/order",
  OTP_VERIFICATION: "/manage/otp",
  CHANGE_NUMBER: "/manage/change-number",
  CHANGE_NUMBER_CONFIRMATION: "/manage/change-number-confirm",
  CHANGE_NUMBER_SUBMITTED: "/manage/change-number-submitted",
  CHANGE_NUMBER_CANCEL: "/manage/change-number/cancel-confirm",
  CHANGE_NUMBER_INELIGIBLE: "/manage/change-number/ineligible",
  CHANGE_NUMBER_FAIL: "/manage/change-number/fail",
  CHANGE_NUMBER_CANCEL_FAIL: "/manage/change-number/cancel-fail",
  REPORT_LOST_SIM: "/manage/report-lost-sim-card",
  REPLACE_WITH_ESIM: "/manage/esim/confirmation/:status?",
  SUSPEND_NUMBER: "/manage/suspend-number",
  SUSPEND_NUMBER_SUMMARY: "/manage/suspend-number/summary",
  SUSPEND_NUMBER_CANCEL_CONFIRMATION:
    "/manage/suspend-number/cancel-confirmation",
  SUSPEND_NUMBER_FAIL: "/manage/suspend-number/fail",
  SUSPEND_NUMBER_INELIGIBLE: "/manage/suspend-number/ineligible",
  TERMINATE_NUMBER: "/manage/terminate-number/:status?",
  CANCEL_TERMINATION: "/manage/cancel-termination/:status?",
  CANCEL_TERMINATION_SUCCESS: "/manage/cancel-termination/success",
  REQUEST_PORT_OUT: "/:channel/port-out-request",
  REVERSE_PORTIN: "/:channel/reverse-portin",
  ORDER_CANCELLATION: "/:action/order-cancellation",
  CANCEL_PORT_IN: "/manage/cancel-port-in",
  MANAGE_RESEND_ESIM_QR: "/manage/resend-esim/:status?",
  CANCEL_PORT_IN_SUCCESS: "/manage/cancel-port-in/success",
  INITIATE_PORT_IN: "/manage/initiate-port-in",
  INITIATE_PORT_IN_SUCCESS: "/manage/initiate-port-in/success",
  REINITIATE_PORT_IN: "/manage/reinitiate-port-in",
  REINITIATE_PORT_IN_SUCCESS: "/manage/reinitiate-port-in/success",
  RESCHEDULE_PORT_IN: "/manage/reschedule-port-in",
  RESCHEDULE_PORT_IN_SUCCESS: "/manage/reschedule-port-in/success",
  OUTSTANDING_BILL_PAYMENT: "/payment/outstanding-bill-payment",
  PAYMENT_RETURN_V3: "/payment/return",
  PAYMENT_QR: "/:channel/payment-qr",
  PAYMENT: "/:channel/payment",
  PAYMENT_CARD: "/:channel/payment/card",
  PAYMENT_AMAZON: "/payment-amazon",
  PAYMENT_RETURN: "/:channel/payment-return",
  LEGACY_PAYMENT_RETURN: "/:channel/payment_return/:order_id",
  PAYMENT_STATUS: "/:channel/payment-status",
  PAYMENT_SUCCESS: "/:channel/payment-success",
  PAYMENT_FAILED: "/:channel/payment-failed",
  PAYMENT_PENDING: "/:channel/payment-pending",
  ACTIVATE: "/:channel/activate",
  ACTIVATE_SUCCESS: "/:channel/activate/success",
  PRE_CHECKOUT: "/:channel/pre-checkout",
  ADDON_SELECTION: "/:channel/addon-selection",
  SELECTED_PACKAGES: "/:channel/selected-packages",
  NEW_NUMBER: "/:channel/new-number",
  PORT_IN_NUMBER: "/:channel/keep-number",
  PERSONAL_DETAILS: "/:channel/personal-details",
  DELIVERY_INFO: "/:channel/delivery-info",
  ORDER_SUMMARY: "/:channel/order-summary",
  SIM_VERIFICATION: "/:channel/sim",
  VERIFY_IDENTITY: "/:channel/verify-identity",
  SUCCESS: "/:channel/success",
  SCHEDULE_DELIVERY: "/schedule_delivery/:order_type/:delivery_type/:status?",
  RESCHEDULE_DELIVERY: "/reschedule_delivery/:order_type?",
  RESCHEDULE_DELIVERY_PAYMENT: "/reschedule_delivery/payment",
  PHONES: "/:channel/phones",
  PHONE: "/shop/phones/:id",
  PHONE_DETAILS: "/:channel/phone-details",
  PAYMENT_CARD_UPDATE: "/manage/update-card/:status",
  SHOP_ORDER_SUMMARY: "/shop/order-summary/:type",
  SHOP_PAYMENT: "/shop/payment",
  SELF_ACTIVATION_DELIVERY: "/self_act_del/order-summary",
  SELF_ACTIVATION_DELIVERY_SUCCESS: "/self_act_del/success",
  UPLOAD_IDENTITY: "/identity/:type",
  SCANNER: "/loadBarcode",
  DASHBOARD: "/dashboard",
  EASY_PAISA_BIND_CALLBACK: "/easy-paisa-callback",
  WEBLOGIN: "/loginweb",
  CLOSEWEBVIEW: "/closewebview",
  EKYC_VERIFY: "/ekyc_verify",
  UPDATE_CARD_SUCCESS: "/updateCardSuccess",
  PROFILE_UPDATE_EMAIL_SUCESS: "/profileUpdateEmailSuccess",
  PING: "/ping",
  ZENDESK: "/zendesk",
  MULTI_LINE_SELECTION: "/multi-line-selection",
  FAKE_DOOR_HOME1: "/land1",
  FAKE_DOOR_HOME2: "/land2",
  FAKE_DOOR_HOME3: "/land3",
  FAKE_DOOR_HOME4: "/land4",
  FAKE_DOOR_HOME5: "/land5",

  SIM_ACTIVATION_ORDER_SUMMARY: "/sim_activation/order-summary",
  SIM_ACTIVATION_PAYMENT_RETURN: "/sim_activation/payment-return",
  SELF_ACTIVATION_ORDER_SUMMARY: "/self_activation/order-summary",
  SURVEY: "/surveys/new",
  IDENTITY_VERIFICATION: "/identity_verification",
  PLAN_SELECTION: "/:channel/plan-selection",
  ESIM_TYPE_SELECTION: "/:channel/esim-selection",
  PHYSICAL_SIM_TYPE_SELECTION: "/:channel/physical-sim-selection",
  CONNECTION_DETAILS: "/:channel/connection-details",
  PROFILE: "/profile",
  ADD_PAYMENT_METHOD: "/:channel/payment-method",
  UPDATE_PAYMENT_METHOD: "/:channel/update-payment-method",
  ENABLED_PAYMENT_METHODS: "/:channel/enabled-payment-methods",
  SAVED_PAYMENT_METHODS: "/:channel/saved-payment-methods",
  PROFILE_ADD_LANGUAGE: "/:channel/language",
  PROFILE_UPDATE_LANGUAGE: "/:channel/update-language",
  PROFILE_EMAIL: "/:channel/email",
  PRIVACY_SETTINGS: "/:channel/privacy-settings",
  USER_DETAILS_CONFIRMATION: "/:channel/user-details-confirmation",
  SIM_ACTIVATION_STATUS: "/:channel/sim-activation-status",
  SIM_ACTIVATION_SUCCESS: "/:channel/sim-activation-success",
  SIM_ACTIVATION_PENDING: "/:channel/sim-activation-pending",
  USER_DETAILS: "/web/user-details",
  AU_USER_DETAILS: "/web/au-user-details",
  OWNER_DETAILS: "/web/owner-details",
  PORTIN_DETAILS: "/web/portin-details",
  DELIVERY_DETAILS: "/web/delivery-details",
  CONTACT_DETAILS: "/web/contact-details",
  MANAGE_SIM_ACTIVATION: "/manage/sim-activation",
  PORTIN_INSTRUCTION: "/manage/portin-instruction",
  MANAGE_SIM_ACTIVATION_CODE: "/loadBarcode",
  MANAGE_ACTIVATE_SIM_CARD: "/manage/activate-sim-card",
  MANAGE_SIM_ACTIVATION_SUCCESS: "/manage/sim-activation-success",
  MANAGE_ESIM_QR: "/manage/esim-qr",
  LOG_IN: "/:channel/login",
  LOGGED_OUT: "/logged_out",
  APP_LINK_AU_ACCOUNT_SUCCESS: "/auidLinkingSuccess",
  SELF_ACTIVATION_SIM_DELIVERY: "/:channel/sa_delivery",
  ESIM_VERIFICATION: "/:channel/ekyc",
  SELF_ACTIVATION_PLAN: "/:channel/plan",
  SCHEDULE_DELIVERY_CONFIRMATION: "/confirmation",
  PORTIN_NUMBER_SELECTION: "/:channel/portin-number-selection",
  VERIFY_IDENTITY_ORDER_SUMMARY: "/verify-identity/order-summary",
  CHANNEL_OTP: "/:channel/otp",
  CIS_REQUEST: "/cis/request_for_cis",
  CIS_REQUEST_HR: "/cis/request_for_cis_to_hr",
  CIS_REQUEST_SUCCESS: "/cis/request_for_cis/success",
  CIS_REQUEST_HR_SUCCESS: "/cis/request_for_cis_to_hr/success",
  DIRECT_LINK_EXPIRED: "/payment/paylink-expired",
  DIRECT_PAYMENT_LINK: "/payment/:paylink",
  OUTSTANDING_BILLS: "/payment/outstanding_bills",
  OUTSTANDING_BILLS_PAYMENT_STATUS: "/payment/outstanding_bills/:status",
  WIRE_CARD_ONE_TIME_PAYMENT: "/wirecard/ipp/one-time-payment",
  SWITCH_TO_ESIM: "/manage/switch-to-esim/:status?",
  MANAGE_ACTION_GENERIC_STATUS: "/manage/:action/:status",
  CIS_PARTNERS_SUCCESS: "/partners/success",
  CIS_PARTNERS: "/partners/:partnerID",
  CIRCLES1_SAD: "/circles1/sa_delivery",
  ERROR_404: "/404",
  ERROR_500: "/500",
  ERROR_429: "/429",
  MAINTENANCE: "/maintenance",
  MANAGE_MANUAL_EKYC: "/manage/manual-ekyc",
  SIM_REPLACEMENT_ORDER_REQUEST: "/manage/sim-replacement-order-request",
  SIM_REPLACEMENT_ORDER_KYC: "/manage/sim-replacement-kyc",
  SIM_REPLACEMENT_DELIVERY_DETAILS: "/manage/sim-replacement-delivery-details",
  SIM_REPLACEMENT_ORDER_SUMMARY: "/manage/sim-replacement-order-summary",
  SIM_REPLACEMENT_ORDER_STATUS: "/manage/sim-replacement-order-status",
  SIM_REPLACEMENT_ORDER_PAYMENT: "/manage/sim-replacement-order-payment",
  SERVICE_REQUEST: "/manage/service-request",
  SERVICE_REQUEST_STATUS: "/manage/service-request-status",
  INELIGIBLE_SCREEN: "/manage/:type/ineligible",
  SERVICE_ORDERS: "/manage/service-orders",
  PAST_SERVICE_REQUESTS: "/manage/past-service-requests",
  PLAN_SWITCH_PLANS: "/manage/plan-switch/plans",
  PLAN_SWITCH_PLAN_DETAILS: "/manage/plan-switch/plan-details",
  PLAN_SWITCH_ORDER_SUMMARY: "/manage/plan-switch/order-summary",
  CANCEL_PORTIN: "/manage/cancel-portin",
  PENDING_ORDERS: "/web/pending-orders",
  PENDING_ORDERS_DETAILS: "/web/pending-orders-details",
  PAYMENT_STATE: "/web/payment-state",
  RESCHEDULE_PAYMENT_STATE: "/:channel/payment-pending",
  RESCHEDULE_ORDER_SUMMARY_PATH: "/reschedule_delivery/review_detail",
  UNSUBSCRIBE: "/unsubscribe"
};

export const forms = {
  PRE_CHECKOUT_FORM: "PreCheckoutForm",
  PERSONAL_DETAILS_FORM: "PersonalDetailsForm",
  CONNECTION_DETAILS_FORM: "ConnectionDetailsForm",
  PORT_IN_FORM: "PortInForm",
  NEW_NUMBER_FORM: "NewNumberForm",
  DELIVERY_INFO_FORM: "DeliveryInfoForm",
  RESCHEDULE_DELIVERY_INFO_FORM: "RescheduleDeliveryInfoForm",
  ORDER_SUMMARY_FORM: "OrderSummaryForm",
  SIM_VERIFICATION_FORM: "SimVerificationForm",
  IDENTITY_VERIFICATION_FORM: "IdentityVerificationForm",
  SELF_ACTIVATION_FORM: "SelfActivationForm",
  UPLOAD_IDENTITY_FORM: "UploadIdentityForm",
  SHOP_PAYMENT_FORM: "ShopPaymentForm",
  MANAGE_ORDER_FORM: "ManageOrderForm",
  DIRECT_PAY_LINK_FORM: "DirectPayLinkForm",
  OUTSTANDING_BILLS_FORM: "OutstandingBillsForm",
  USER_LOGIN_FORM: "UserLoginForm",
  USER_LOGIN_OTP_FORM: "UserLoginOTPForm",
  USER_SIGNUP_FORM: "UserSignupForm",
  USER_DETAILS_CONFIRMATION_FORM: "UserDetailsConfirmationForm",
  PHONES_FORM: "PhonesForm",
  PAYMENT_FORM: "PaymentForm",
  REPORT_LOST_SIM_FORM: "ReportLostSimForm",
  REQUEST_PORTOUT_FORM: "RequestPortOutForm",
  REVERSE_PORTIN_FORM: "ReversePortInForm",
  ORDER_CANCELLATION_FORM: "OrderCancellationForm",
  PROFILE_FORM: "ProfileForm",
  PORTIN_NUMBER_SELECTION_FORM: "PortInNumberSelectionForm",
  TERMINATION_STATUS_FORM: "TerminationStatusForm",
  OUTSTANDING_BILL_PAYMENT_FORM: "OutstandingBillPaymentForm",
  SUSPEND_NUMBER_FORM: "SuspendNumberForm",
  WIRECARD_ONE_TIME_PAYMENT_FORM: "WireCardOneTimePaymentForm",
  CHANGE_NUMBER_FORM: "ChangeNumberForm",
  AUTHORIZER_FORM: "AuthorizerForm",
  SWITCH_TO_ESIM_FORM: "SwitchToEsimForm",
  TERMINATE_NUMBER_FORM: "TerminateNumberForm",
  CHANNEL_OTP_FORM: "ChannelOTPForm",
  CIS_REQUEST_FORM: "CisRequestForm",
  CIS_REQUEST_HR_FORM: "CisRequestHrForm",
  CIS_PARTNERS_FORM: "CisPartnersForm",
  MANUAL_EKYC_FORM: "ManualEkycForm",
  SERVICE_REQUEST_STATUS_FORM: "ServiceStatusRequestForm",
  SERVICE_REQUEST: "ServiceRequest",
  PLAN_SWITCH_PLANS_FORM: "PlanSwitchPlansForm",
  PLAN_SWITCH_PLAN_DETAILS_FORM: "PlanSwitchPlanDetailsForm",
  PLAN_SWITCH_ORDER_SUMMARY_FORM: "PlanSwitchOrderSummaryForm",
  CANCEL_PORTIN_FORM: "CancelPortinForm",
  PAYMENT_STATUS_FORM: "PaymentStatusForm"
};

export const DEFAULT_KEYS_TO_FETCH = ["appSettings", "locale"];

export const PENDING = "PENDING";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const STATUS = "STATUS";

export const ACTION_URLS = {
  activate_sim_card: paths.ACTIVATE,
  initiate_portin: paths.INITIATE_PORT_IN,
  reinitiate_portin: paths.REINITIATE_PORT_IN,
  reschedule_port_in: paths.RESCHEDULE_PORT_IN,
  cancel_portin: paths.CANCEL_PORT_IN,
  payment_status: paths.PAYMENT_STATUS,
  payment_success: paths.PAYMENT_SUCCESS,
  payment_pending: paths.PAYMENT_PENDING,
  payment_failed: paths.PAYMENT_FAILED,
  reupload_identity: paths.UPLOAD_IDENTITY,
  report_lost_esim_card: paths.REPORT_LOST_SIM
};

export const PAYMENT_STATUS_URLS = {
  success: paths.PAYMENT_SUCCESS,
  pending: paths.PAYMENT_PENDING,
  failed: paths.PAYMENT_FAILED
};

export const PAYMENT_STATUS_URLS_CXOS = {
  success: paths.PAYMENT_SUCCESS,
  created: paths.PAYMENT_PENDING,
  pending: paths.PAYMENT_PENDING,
  failure: paths.PAYMENT_FAILED
};

export const OUTSTANDING_PAYMENT_STATUS_URLS = {
  [SUCCESS]: paths.OUTSTANDING_BILLS_PAYMENT_STATUS_SUCCESS,
  [PENDING]: paths.OUTSTANDING_BILLS_PAYMENT_STATUS_IN_PROGRESS,
  [FAILURE]: paths.OUTSTANDING_BILLS_PAYMENT_STATUS_FAILURE,
  [STATUS]: paths.OUTSTANDING_BILLS_PAYMENT_STATUS.replace(":status", "status")
};

export const WEBSITE_V2 = "web";
export const SELF_ACT_DEL = "self_act_del";
export const SELF_ACTIVATION_SIM = "self_activation";
export const SIM_ACTIVATION = "sim_activation";
export const ESIM = "esim";
export const WEB = "web";
export const RETAIL = "retail";

export const ORDER_CHANNEL_MAPPING = {
  web: WEB,
  retail: RETAIL,
  website: WEBSITE_V2,
  circles2: WEBSITE_V2,
  circles100: WEBSITE_V2,
  combo: WEBSITE_V2,
  phoneonly: WEBSITE_V2,
  dataonly: WEBSITE_V2,
  circles3: WEBSITE_V2,
  circles10: WEBSITE_V2,
  circles25: WEBSITE_V2,
  circles45: WEBSITE_V2,
  circles55: WEBSITE_V2,
  circles1: SELF_ACT_DEL,
  familyplan: SELF_ACT_DEL,
  circleslarpu: SELF_ACT_DEL,
  self_activation: SIM_ACTIVATION,
  "e-sim": ESIM
};

export const ROOT_CHANNEL = ":channel";
export const PHONE_ONLY_CHANNEL = "phoneonly";
export const PAYMENT_ONLY_MODE = "payment";
export const COMBO_CHANNEL = "combo";
export const CIRCLES1_CHANNEL = "circles1";
export const CIRCLES2_CHANNEL = "circles2";
export const CIRCLES100_CHANNEL = "circles100";
export const CIRCLES10_CHANNEL = "circles10";
export const CIRCLES25_CHANNEL = "circles25";
export const CIRCLES45_CHANNEL = "circles45";
export const CIRCLES55_CHANNEL = "circles55";
export const FAMILY_PLAN = "familyplan";
export const CIRCLESLARPU = "circleslarpu";
export const WEB_CHANNEL = "web";
export const PARTNERS_CHANNEL = "partners";
export const ROADSHOW_CHANNEL = "roadshow";
export const PAYMENT_CHANNEL = "payment";

export const WEB_CHANNELS = [
  WEB_CHANNEL,
  "website",
  "website_v2",
  CIRCLES2_CHANNEL,
  CIRCLES100_CHANNEL,
  COMBO_CHANNEL,
  "dataonly",
  "circles3",
  CIRCLES1_CHANNEL,
  FAMILY_PLAN,
  CIRCLESLARPU,
  PHONE_ONLY_CHANNEL,
  "liveon2",
  "liveon3",
  "liveon4",
  "liveon5",
  "liveon6",
  "liveon7",
  "cis",
  "e-sim",
  ROADSHOW_CHANNEL,
  CIRCLES10_CHANNEL,
  CIRCLES25_CHANNEL,
  CIRCLES45_CHANNEL,
  CIRCLES55_CHANNEL
];

export const SIM_ACTIVATION_CHANNELS = [
  "sim_activation",
  "sim_activation_id",
  "blackhawk",
  "self_activation",
  "e-sim"
];

export const AU_TO_POVO_CHANNEL = "au_to_povo";
export const DEFAULT_CHANNEL = "web";

export const WORKFLOW_CHANNELS = [
  ...WEB_CHANNELS,
  ...SIM_ACTIVATION_CHANNELS,
  AU_TO_POVO_CHANNEL
];

export const TELCO_BENEFIT_TYPES = {
  TELCO_DATA: "telco_data",
  TELCO_VOICE: "telco_voice",
  TELCO_SMS: "telco_sms",
  TELCO_ADDON: "telco_addon"
};

export const TELCO_WAIVER_TYPES = {
  TELCO_BILL_WAIVER: "telco_bill_waiver",
  TELCO_ADDON_WAIVER: "telco_addon_waiver"
};

export const TELCO_STATUS = {
  TERMINATED: "Terminate",
  ACTIVE: "Active"
};

export const TELCO_DISCOUNT_TYPES = {
  TELCO_REGISTRATION_DISCOUNT: "telco_registration_discount",
  TELCO_SUBSCRIPTION_DISCOUNT: "telco_subscription_discount"
};

export const ONE_TIME_DISCOUNT_TYPES = [
  TELCO_DISCOUNT_TYPES.TELCO_REGISTRATION_DISCOUNT,
  TELCO_DISCOUNT_TYPES.TELCO_SUBSCRIPTION_DISCOUNT
];

export const TELCO_DATA = {
  CURRENT_TELCO: "CURRENT_TELCO",
  DONOR_CODE: "DONOR_CODE",
  DONOR_TELCO_ID: "DONOR_TELCO_ID"
};

export const CONSENT_TYPES = {
  MANDATORY_SCROLL: "MANDATORY_SCROLL",
  IMPLICIT: "IMPLICIT"
};

export const ADDON_BENEFIT_TYPES = ["telco_addon_discount", "telco_addon_free"];

export const PLAN_BENEFITS_TYPES = ["telco_plan_discount"];

export const STANDALONE_WORKFLOW_PATHS = [
  "/web/activate",
  "/web/success",
  "/web/login",
  "/web/signup",
  "/web/confirm-email",
  "/web/verify-otp",
  "/web/user-details",
  "/web/owner-details",
  "/web/portin-details",
  "/web/delivery-details",
  "/web/contact-details",
  "/verify-identity/ekyc",
  "/verify-identity/order-summary",
  "/verify-identity/success",
  "/au_to_povo/login",
  "/au_to_povo/signup"
];

export const PAYFAST_CALLBACK_CODES = {
  PAYMENT_SUCCESS: "000",
  PAYMENT_CANCELLED: "901",
  PAYMENT_FAILED: "91"
};

export const SUB_STATE_ERRORS = {
  SELFPICKUP_NOT_AVAILABLE: "SELFPICKUP_NOT_AVAILABLE"
};

export const STANDALONE_WORKFLOW_ROUTES = [paths.PAYMENT_SUCCESS];

export const DEFAULT_TERMINATION_REASONS = [
  "termination_reason_different_number",
  "termination_reason_contract",
  "termination_reason_incorrect_details",
  "termination_reason_mind",
  "termination_reason_other"
];

export const SIGNINTYPE = ":signintype";
export const SIGNINTYPE_PATHS = {
  LOGIN: "login",
  SIGNUP: "signup"
};

// These paths are open to all visitors
export const publicPaths = {
  LOGIN_PAGE: `/:channel/${SIGNINTYPE}`,
  SIGNUP_PAGE: `/:channel/${SIGNINTYPE}`,
  CONFIRM_EMAIL: "/:channel/confirm-email",
  SELECT_EMAIL: "/:channel/select-email",
  VERIFY_OTP: `/:channel/verify-otp/${SIGNINTYPE}`,
  LINE_AUTHENTICATION: "/line_authentication",
  YAHOO_AUTHENTICATION: "/yahoo_authentication",
  GOOGLE_AUTHENTICATION: "/google_authentication",
  FACEBOOK_AUTHENTICATION: "/facebook_authentication",
  APPLE_AUTHENTICATION: "/apple_authentication",
  AU_AUTHENTICATION: "/au_authentication",
  AU_LOST_SERVICE: "/au_lost_service",
  //TODO This is added only for testing purpose , need to remove this after au lost service page is developed
  MOCK_AU_LOST_SERVICE: "/dummy_au_lost_service",
  AU_LOST_SERVICE_USER_CONFIRM: "/:channel/au-lost-service-user-confirm"
};

export const AUTH_MODES = {
  ENHANCED_EMAIL_OTP: "ENHANCED_EMAIL_OTP"
};
// This is the default web view value send by the mobile application via query params
export const DEFAULT_WEB_VIEW_VALUE = "1";
export const tabTypes = {
  PILL: "PILL"
};

// constant to check whether payment action is a redirect or submit
export const POST_PAYMENT_REQUEST_ACTION_TYPES = {
  SUBMIT: "submit",
  REDIRECT: "redirect"
};

export const PAYMENT_METHODS = {
  AMAZON_PAY: "amazonPay",
  APPLE_PAY: "applePay",
  GOOGLE_PAY: "googlePay"
};

export const PAYMENT_METHODS_NAMES = {
  JAZZCASH: "jazzcash_text",
  EASYPAISA: "easypaisa_text"
};

export const PAYMENT_TYPE = {
  WALLET_PAYMENT: "wallet payment"
};

export const NODE_ENVIRONMENT = {
  DEVELOPMENT: "development",
  PRODUCTION: "production"
};

export const CALL_BACK_URL = {
  LINE: `${window.location.origin}${publicPaths.LINE_AUTHENTICATION}`,
  YAHOO: `${window.location.origin}${publicPaths.YAHOO_AUTHENTICATION}`,
  GOOGLE: `${window.location.origin}${publicPaths.GOOGLE_AUTHENTICATION}`,
  FACEBOOK: `${window.location.origin}${publicPaths.FACEBOOK_AUTHENTICATION}`,
  AMAZON_PAY: `${window.location.origin}${paths.PAYMENT_AMAZON}`,
  APPLE: `${window.location.origin}${publicPaths.APPLE_AUTHENTICATION}`,
  AU: `${window.location.origin}${publicPaths.AU_AUTHENTICATION}`,
  AU_LOST_SERVICE: `${window.location.origin}${publicPaths.AU_LOST_SERVICE}`
};

export const SIM_TYPES = {
  PHYSICAL_SIM: "PHYSICAL_SIM",
  E_SIM: "E_SIM",
  PHYSICALSIM: "physicalsim",
  ESIM: "esim",
  SIM_TYPE: "SIM_TYPE",
  E_SIM_CAP: "eSIM", // added for CXOS order creation payload
  eSIM: "ESIM",
  ESIM_CAP: "ESIM" //added for manageorders
};

export const CONTRACT_TYPES = {
  NEW: "NEW",
  PORT_IN: "PORT_IN",
  PORTIN: "PORTIN" // created for CXOS portIn payload
};

export const CONTRACT_ITEM_TYPES = {
  NEW_NUMBER: "NEW_NUMBER",
  PORTIN_NUMBER: "PORTIN_NUMBER"
};

export const ORDER_TYPES = {
  SIM_ONLY: "Sim Only",
  SERVICE_ORDER: "Service Order",
  SIM_REPLACEMENT: "SIM_REPLACEMENT"
};

export const ORDER_CATEGORY = {
  NEW: "new",
  SIM_REPLACEMENT: "sim-replacement"
};

export const PLAN_TYPE = {
  POSTPAID: "postpaid",
  PREPAID: "prepaid"
};

export const PAYMENT_METHOD_CARD_TYPES = {
  CARD: "Card",
  WALLET: "wallet"
};

export const CUSTOMER_TYPE = {
  NEW: "new",
  EXISTING: "existing"
};

export const DEFAULT_PREPAID_VALUES = {
  sku: "PREPAID_SKU",
  title: "Prepaid",
  price: "0",
  recurrent: false
};

export const EXPRESS_DELIVERY = "Express Delivery";
export const SPECIAL_DELIVERY = "Special Delivery";

export const NUMBER_TYPES = {
  PORT_IN: "port_in",
  NEW_NUMBER: "new_number",
  PORTIN_NUMBER: "Transfer Number",
  NEW: "New Number"
};

export const PHONE_PAYMENT_OPTIONS = {
  FULL: "full",
  IPP: "installment",
  SPLIT: "split"
};

export const OUTSTANDING_BILL_REFERRAL_FROM_TYPE = {
  MANAGE_ORDER: "MANAGE_ORDER",
  DIRECT_LINK: "DIRECT_LINK"
};

export const RESPONSE_STATUS = {
  FAILURE: "FAILURE",
  SUCCESS: "SUCCESS",
  SUBMITTED: "SUBMITTED"
};

export const SOCIAL_MEDIA_TYPES = {
  LINE: "LINE",
  YAHOOJP: "YAHOOJP",
  GOOGLE: "GOOGLE",
  FACEBOOK: "FACEBOOK",
  APPLE: "APPLE",
  TWITTER: "TWITTER",
  AU_LOGIN: "AU"
};

export const COUNTRIES = {
  JP: "jp"
};

export const ERROR_CODES = {
  missingResourceForSubmitKycRequest: 400119,
  otpRegenerate: 422004,
  maximumRetryLogin: 422005,
  maximumRetrySignup: 422006,
  pendingOtpSignup: 422019,
  maximumRetryOtt: 422026,
  notEligibleForTermination: 4121101,
  ottExpired: 422025,
  otpExpired: 422004,
  ottVerificationBlocked: 422035,
  resendOttBlockled: 422024,
  invalidOtp: 4221402,
  incorrectOtp: 422011,
  numberAndDeliverySlotAvailability: 48,
  invalidOtpPortIn: 422028,
  maximumOrderError: 26,
  updateCardInvalidOtp: 4220010002,
  rateLimitError: 429,
  signInTokenMisMatch: 400183,
  emailAlreadyTaken: 422032,
  guestUserRealEmailAlreadyTaken: 400185
};

export const RESEND_OTP_ERROR_CODES = ["400001", "400013", "422004", "422005"];

export const PORTIN_NUMBER_VERFICATION = "PORTIN_NUMBER_VERFICATION";

export const ORDER_STATUS = {
  CREATED: "CREATED",
  IC: "OIC",
  FAILED: "FAILED",
  PLACED: "PLACED",
  APPROVED: "APPROVED",
  DPG: "DPG",
  DFL: "DFL",
  APG: "APG",
  AIP: "AIP",
  ASU: "ASU",
  AFL: "AFL",
  PENDING: "PENDING"
};
export const SHIPMENT_FAILED_STATUS = [ORDER_STATUS.DFL];

export const ELIGIBLE_ORDER_STUTSES = ["TSU", "CAN", "OFL", "TFL"];

export const ORDER_STATE = ["OIC", "CAN", "OFL"];
export const ORDER_STATE_VALUE = {
  OIC: "OIC",
  CAN: "CAN",
  OFL: "OFL"
};

export const PAYMENT_STATUS = {
  SUCCESS: "success"
};

export const TERMINATE_ACTION_STATUS = {
  UNFINISHED: "UNFINISHED",
  FAIL: "FAIL"
};

export const PORTOUT_IN_PROGRESS = "IN_PROGRESS";

export const TERMINATION_PENDING_STATUSES = [
  "REGISTERED",
  "SUBMITTED",
  "IN_PROGRESS",
  "UNFINISHED",
  "SCHEDULED"
];
export const TERMINATION_COMPLETED_STATUS = "DONE";
export const TELCO_ACTIVATION_FAILED = "TFL";
export const TELCO_ACTIVATION_SUCCESS = "TSU";
export const PORTOUT_PENDING_STATUSES = [
  "ONGOING_QUEUED",
  "QUEUED",
  "ONGOING_PUBLISHED",
  "PUBLISHED",
  PORTOUT_IN_PROGRESS
];
export const PORTOUT_FAILED_STATUSES = ["FAILED"];
export const PORTOUT_COMPLETED_STATUSES = [
  "NETWORK_PORTOUT",
  "SCHEDULED_TERMINATION",
  "DONE"
];

export const ESIM_FAQ_URL =
  "https://circlesasiasupport.zendesk.com/hc/en-us/categories/900000106743-ESIM";

export const PLAN_SOURCE_COMBO = "SPLIT_COMBO_FLOW";
export const PLAN_SOURCE_PHONE_ONLY = "SPLIT_PHONE_ONLY";
export const PLAN_SOURCE_DEFAULT = "DEFAULT";
export const REPORT_LOST_SIM_REASON = "Customer initiated due to lost sim";

export const DELIVERY_METHOD_TYPE = {
  HOME: "home",
  POP_STATION: "pop_station",
  INSTANT_PICK_UP: "instant_pick_up"
};
//contains value to differentiate between our default page flow or a direct link
export const REFERER_TYPE = {
  DEFAULT: "DEFAULT",
  DIRECT_LINK: "DIRECT_LINK"
};

export const LOGIN_REDIRECT_CHANNEL_MAPPING = {
  [AU_TO_POVO_CHANNEL]: DEFAULT_CHANNEL
};

export const VERIFY_IDENTITY_CHANNEL = "verify-identity";

export const TRANSACTION_STATUS_TIMEOUT = 10;

export const STATUS_TYPE = {
  TRANSACTION: "transaction"
};

export const PAYMENT_TYPES = {
  ADYEN: "adyen",
  STRIPE: "stripe",
  MOCK: "mock",
  PAYFAST: "payfast"
};

export const LOST_SIM = "LOST_SIM";

export const STD = "STD";

export const DOB_SEPARATOR = "-";
export const DOB_FORMAT = "DD-MM-YYYY";
export const SECURITY_DOB_FORMAT = "YYYY-MM-DD";
export const KYC_DOB_FORMAT = "YYYYMMDD";
export const JP_DOB_FORMAT = "YYYY年MM月DD日";

export const PRODUCT_TYPE = { addon: "ADDON", nilclass: "NilClass" };

export const OUTSTANDING_PAYMENT_STATUS = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  SUCCESS: "OK"
};

export const OUTSTANDING_BILL_STATUS = {
  OK: "OK",
  INVALID_SYNC_OR_SEND_STATUS: "INVALID_SYNC_OR_SEND_STATUS",
  NO_OPEN_BILLS: "NO_OPEN_BILLS",
  IN_PROGRESS: "IN_PROGRESS"
};

export const UPDATE_TOKEN_TO_APP_URI = "webfront://updatetoken";
export const SEND_DATA_TO_APP_URI = "webfront://data_analytics";

// http status error codes
export const CONFLICTING_ORDERS_STATUS = 409;
export const UNAUTHORIZED_HTTP_CODE = 401;
export const TOKEN_INVALID_HTTP_CODE = 403;

//Recaptcha error codes
export const RECAPTURE_TOKEN_BROWSER_ERROR = 401015;

export const BUTTON_THROTTLE_SETTINGS = {
  TIME_DELAY: 1000,
  THROTTLE_SETTINGS: {
    trailing: false
  }
};

export const DEFAULT_REGEX = {
  PERSONAL_CONTACT_NUMBER: "^03[0-9]{2}[0-9]{7}$"
};

export const SET_DATA_KEYS = {
  LOCATION_INFO: "locationInfo"
};

export const LOCATION_ACCESS_CHANNELS = {
  WEB: "web",
  APP: "app"
};

export const FILE_TYPE_MAP = {
  PDF: "application/pdf",
  PNG: "image/png",
  JPG: "image/jpeg",
  JPEG: "image/jpeg"
};

export const EASY_PAISA_PAYMENT_ID = "PMP-7UJH654G8P";

export const CAMERA_PERMISSION_STATUS = {
  PROMPT: "prompt",
  GRANTED: "granted",
  DENIED: "denied"
};

export const BROWSER_PERMISSION_QUERY_NAMES = {
  CAMERA: "camera"
};

export const TERMINATION_REASONS = [
  {
    key: "Data Speed is Low",
    id: "I encountered issues with the network"
  },
  {
    key: "I had bad customer service",
    id: "I had bad customer service"
  },
  {
    key: "I had billing issues",
    id: "I had billing issues"
  },
  {
    key: "My port-in failed",
    id: "My port-in failed"
  },
  {
    key: "I was offered a better deal from another telco",
    id: "I was offered a better deal from another telco"
  },
  {
    key: "I’m moving overseas",
    id: "I’m moving overseas"
  },
  {
    key: "I have another primary number and I don’t need this one",
    id: "I have another primary number and I don’t need this one"
  },
  {
    key: "Other reasons",
    id: "other"
  }
];

export const IN_APP_PURCHASE = "in_app_purchase";

export const EASY_PAISA_MINI_APP_URL = process.env.REACT_APP_MINI_APP_URL;

export const defaultSelectedCategory = "Gold";
export const goldenText = "Golden";

export const ITEM_CATEGORY = {
  PLAN: "Plan",
  ADDON: "Add-on"
};
export const THIRD_PARTY_URL = "daraz";

export const JOURNEY_FLOW = {
  ONBOARDING: "onboarding",
  SIM_REPLACEMENT: "simreplace",
  RESCHDEULE_DELIVERY: "rescheduledelivery",
  IN_APP_PURCHASE: "in-app-purchase",
  OLD_APP_VERSION: "old-app-versions",
  RETRY: "retry_payment"
};

export const ORDER_TYPE = {
  BUNDLE: "BUNDLE",
  ADDON: "ADDON"
};

export const EASYPAISA_ERROR = {
  "0014": "ACCOUNT_DOES_NOT_EXIST",
  "0013": "LOW_BALANCE",
  E000: "EASY_PAISA_GENERIC_ERROR",
  "0026": "ACCOUNT_DOES_NOT_EXIST",
  "0029": "TXN_AMOUNT_BEYOND_LIMITS"
};

export const APP_DEEPLINKS = {
  PRODUCTION: "https://onic-pk.app.link/easypaisa_binding?url=",
  PREPRODUCTION: "https://onic-pk.test-app.link/easypaisa_binding?url="
};

export const GROUP_PRODUCT_FREQUENCY_MAPPING = {
  WEEK: "Week",
  MONTH: "Month",
  DAY: "Week",
  MONTHS: "Months",
  MONTHLY: "Monthly",
  WEEKLY: "Weekly",
  WEEKS: "Weeks"
};
export const PAYMENT_MODULE_LOCALE_KEYS = [
  "one_time_payment_text",
  "pay_now",
  "price_condition_txt",
  "total_amount_text",
  "eaisy_paisa_ac_label",
  "one_time_payment_header_txt",
  "all_mobile_wallets_text",
  "easypaisa_pending_title",
  "please_retry",
  "easypaisa",
  "in_app_payment_failed",
  "order_pending",
  "order_number",
  "in_app_payment_successful",
  "in_app_payment_successful_msg",
  "awesome_msg",
  "redirect_to_payment_partner_message",
  "select_payment_method_title",
  "payment_refund_message",
  "card_text",
  "save_card_future_payment",
  "jazzcash_text",
  "easypaisa_text",
  "bank_account_text",
  "other_cards_txt",
  "make_payment",
  "data_loading_error_message_title",
  "retry",
  "easypaisa_payment_instruction",
  "easypaisa_binding",
  "in_app_payment_system_failed_msg",
  "ok",
  "payment.",
  "in_app_payment_canceled_title",
  "in_app_payment_canceled_msg",
  "success_ok_popup",
  "continue_"
];

export const MARKETING_WEB_NAVIGATION = [
  "login_signup_path",
  "one_promo_item_count",
  "loyalty_earn_points_plan_card",
  "pick_your_toppings",
  "pick_your_toppings_subtitle",
  "payment_refund_message",
  "earned_point_count",
  "popular_payment_methods",
  "most_asked_questions",
  "faq_precheckout_no_contract_question",
  "faq_precheckout_no_contract_answer",
  "faq_precheckout_exceed_question",
  "faq_precheckout_exceed_answer",
  "more_faqs",
  "total_inclusive_tax",
  "monthly_pack_price",
  "next",
  "continue",
  "verify_account_by_otp_command",
  "verify_account_by_otp_instructions",
  "resend_activation_code_label",
  "sign_up",
  "enter_your_email",
  "signup_agreement_message",
  "navigate_to_login_page",
  "user_login_email_placeholder",
  "error_cannot_be_blank_signup",
  "error_invalid_email",
  "expiring_in",
  "continue",
  "verify_account_by_otp_command",
  "verify_account_by_otp_instructions",
  "resend_activation_code_label",
  "timer_expried",
  "timer_expired_message",
  "ok",
  "simAndNumberStep",
  "detailsStep",
  "reviewStep",
  "Payment",
  "select_sim_type",
  "label_PHYSICAL_SIM",
  "label_new_number",
  "label_number_transfer",
  "label_E_SIM",
  "esim_quick_introduction_message",
  "esim_compatible_list_title",
  "physical_quick_introduction_message",
  "e_sim_consent_disclaimer_msg",
  "please_give_consent",
  "select_your_number",
  "abel_new_number",
  "abel_new_number",
  "eligibility_message_alert",
  "convert_number_type_description",
  "choose_your_number",
  "freenumber_label",
  "premiumnumber_label",
  "your_new_number_is",
  "Gold_label",
  "Platinum_label",
  "Lucky_label",
  "Unknown_label",
  "CategoryA_label",
  "find_your_dream_number",
  "no_number_match",
  "try_different_number",
  "refresh_numbers",
  "current_port_number",
  "error_cannot_be_blank",
  "personal_details_contact_number_placeholder_ufone_portin",
  "port_in_which_telco",
  "all_fields_mandatory",
  "load_more",
  "faq_precheckout_order_onic_psim_question",
  "faq_precheckout_order_onic_psim_answer",
  "faq_precheckout_exceed_question",
  "faq_precheckout_exceed_answer",
  "faq_precheckout_dialing_roaming_activation_question",
  "faq_precheckout_dialing_roaming_activation_answer",
  "faq_precheckout_available_payment_methods_question",
  "faq_precheckout_available_payment_methods_answer",
  "faq_precheckout_order_onic_esim_question",
  "faq_precheckout_order_onic_esim_answer",
  "faq_precheckout_port_number_onic_question",
  "faq_precheckout_port_number_onic_answer",
  "faq_precheckout_recharge_onic_plan_question",
  "faq_precheckout_recharge_onic_plan_answer",
  "login_with",
  "email_number",
  "navigate_to_signup_page",
  "personal_details",
  "pending_orders",
  "pending_orders_menu_desc",
  "privacy_and_security",
  "privacy_and_security_info",
  "logout",
  "logout_message_profile_page",
  "logout_confirm",
  "cancel",
  "yes",
  "bundle_discount_price",
  "location_picker",
  "promo_item_count"
];

export const CURRENCY_SYMBOL = "Rs. ";

export const LONG_TERM_FRQUENCY_VALUES = {
  WEEK: "7",
  MONTH: "30",
  PROD_MONTH: "31",
  PROD_WEEK: "8"
};

export const AWS_IMAGE_PATH =
  "https://circles-marketing.s3.ap-southeast-1.amazonaws.com/CXOS/";

export const SELF_PICKUP_ORDER_STATUSES_LOCALE_IDS = {
  IN_PROGRESS: "self_pickup_in_progress",
  FAILED: "self_pickup_failed",
  CANCELED: "self_pickup_canceled",
  SUCCESS: "self_pickup_success"
};

export const SELF_PICKUP_ORDER_MAPPINGS = {
  IN_PROGRESS: "SIM Delivery In Progress",
  FAILED: "SIM Delivery Failed",
  CANCELED: "Shipment Cancelled",
  SUCCESS: "SIM Delivery Successful"
};

export const IDENTITY_CONFIRMATION_STATES = {
  PROCESSING: "processing",
  CANCEL: "cancel",
  SUCCESS: "success",
  FAILED: "fail"
};

export const SELF_PICKUP_DISABLED_PID_LIST = ["PID-ZXG885P5VY"]
export const EPIC_PLAN ="EPIC1"